export const ORDER_INTENTS = {
    SEARCH_INPUT: "search-input",
    EXPORT_BTN: "export-btn",
    EXPORT_ORDER_INTENT_DETAILS: "export-order-intent-details",
    EXPORT_ORDER_INTENT_SUMMARY: "export-order-intent-summary",
    EXPORT_ORDER_INTENT_NOTE: "export-order-intent-note",
};
